import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "section" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Welcome to Bored of Things", -1)
const _hoisted_4 = { class: "columns" }
const _hoisted_5 = { class: "column" }
const _hoisted_6 = { class: "column" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<section class=\"section\"><div class=\"container\"><div class=\"content\"><h1 class=\"\">Are you bored of <s>social media?</s> the algorithm?</h1><div class=\"is-size-5\"><p>Bored of Things lets users like you decide what&#39;s on the front page by providing a finite amount of space per topic.</p><p>If you don&#39;t like a post, replace it with your own!</p><p>And, if you want to make sure no one replaces your post, lock it.</p></div></div></div></section>", 1)
const _hoisted_8 = { class: "section" }
const _hoisted_9 = { class: "container" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Explore", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "is-size-5" }, "Check out what boards are available by going to the Board Browser, or create your own and share it with others. ", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Board Browser ")
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "ml-3 fas fa-caret-square-right" }, null, -1)
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PostComponent = _resolveComponent("PostComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_PostComponent, { static_post: _ctx.post1 }, null, 8, ["static_post"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_PostComponent, { static_post: _ctx.post2 }, null, 8, ["static_post"])
          ])
        ])
      ])
    ]),
    _hoisted_7,
    _createElementVNode("section", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _hoisted_11,
        _hoisted_12,
        _createElementVNode("div", {
          class: "button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goto_boardBrowser && _ctx.goto_boardBrowser(...args)))
        }, _hoisted_15)
      ])
    ])
  ], 64))
}